import React from 'react';
import StandardFormView from '../StandardComponents/StandardFormView/StandardFormView';

/**
 * GrantEntitlementDialog — thin wrapper around StandardFormView for granting tiers
 * to an organization. Form fields live in GrantEntitlementModal.
 */
export default function GrantEntitlementDialog({ open, org, onClose, onGranted }) {
  return (
    <StandardFormView
      open={open}
      onClose={onClose}
      flag="add"
      title="Grant Tiers to Organization"
      subTitle={org?.organization_name}
      isPage="grant-entitlement"
      editItems={org}
      layoutMode="basic"
      getAllData={onGranted}
    />
  );
}
